import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors';
import es from 'vuetify/lib/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { es },
    current: 'es'
  },
  theme: {
    themes: {
      light: {
        // Paleta de marca. Los mismos valores viven como $pw-* en
        // src/styles/variables.scss, que es la fuente para SASS y CSS.
        // Al tocar uno hay que tocar el otro.
        primary: '#104B94',
        secondary: '#6B7280',
        accent: '#0D3E7A',
        // Antes no se declaraban y Vuetify caía en los verdes y naranjos de
        // fábrica de Material, que desentonan junto al azul de marca. Los usa
        // el semáforo de Metas.vue y los chips de estado de toda la app.
        success: '#16A34A',
        warning: '#D97706',
        error: '#DC2626',
        info: '#0EA5E9',
        link: '#2678F2'
      },
      dark: {
        primary: colors.blue.lighten3
      }
    }
  }
});
